import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  return (
    <SonnerToaster
      position="bottom-right"
      theme="dark"
      visibleToasts={3}
      gap={8}
      closeButton={false}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "alia-toast",
        },
      }}
    />
  );
}
